// extracted by mini-css-extract-plugin
export default {"root":"tooltip_root__rGfV-","tooltip":"tooltip_tooltip__O1lI-","arrow":"tooltip_arrow__5XnSO"};